import { Grid, Typography } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { If, Then } from "react-if";

const CheckoutToggleOutput = observer(
	({ tab, conditionTab, title, result }) => {
		return (
			<If condition={tab === conditionTab}>
				<Then>
					<Typography
						variant="h4"
						style={{
							padding: 30,
							marginBottom: -50,
							textAlign: "center",
							position: "relative",
						}}
					>
						{title}
					</Typography>
					<Grid container style={{ marginTop: 20 }}>
						<Grid
							item
							xs={12}
							style={{
								paddingLeft: 8,
								paddingRight: 8,
							}}
						>
							{result}
						</Grid>
					</Grid>
				</Then>
			</If>
		);
	}
);

export default CheckoutToggleOutput;
